import ExpiredStorage from "expired-storage";
import type { FC } from "react";
import { useEffect } from "react";
import type { FallbackProps } from "react-error-boundary";

const expiredStorage = new ExpiredStorage();

const CHUNK_FAILED_ERROR_MESSAGE_REGEX = /Loading (?:CSS )?chunk [\d]+ failed/;

export const isChunkFailedError = (error: Error | undefined): boolean =>
  CHUNK_FAILED_ERROR_MESSAGE_REGEX.test(error?.message ?? "");

// Handles failed lazy loading of a JS/CSS chunk.
export const handleChunkFailure = () => {
  if (!expiredStorage.getItem("chunk_failed")) {
    expiredStorage.setItem("chunk_failed", "true", 10);
    window.location.reload();
  }
};

export const ErrorFallback: FC<FallbackProps> = ({ error }) => {
  useEffect(() => {
    if (isChunkFailedError(error)) {
      handleChunkFailure();
    }
  }, [error]);

  return null;
};
